function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Exclusion 1",
    d: "M22 44a22.006 22.006 0 0 1-8.564-42.271 22.006 22.006 0 0 1 17.127 40.542A21.864 21.864 0 0 1 22 44zm-6.415-32.814a1.013 1.013 0 0 0-.733.32l-3.046 3.046a1.71 1.71 0 0 0-.389.538 2.23 2.23 0 0 0-.206.653c0 .031-.008.185-.023.458a5.681 5.681 0 0 0 .092 1.133 11.922 11.922 0 0 0 .435 1.717 14.505 14.505 0 0 0 .962 2.221 21.623 21.623 0 0 0 1.695 2.668 25.139 25.139 0 0 0 2.656 3.022 23.932 23.932 0 0 0 3.8 3.206 20.2 20.2 0 0 0 3.194 1.751 10.752 10.752 0 0 0 2.381.733 10.642 10.642 0 0 0 1.408.148c.121 0 .222 0 .3-.011s.121-.012.138-.012a2.261 2.261 0 0 0 .653-.206 1.728 1.728 0 0 0 .538-.39l3.045-3.022a1.05 1.05 0 0 0 .32-.916 1.153 1.153 0 0 0-.572-.755l-4.419-2.61h-.023a1.2 1.2 0 0 0-.618-.138 1.413 1.413 0 0 0-.962.366l-1.311 1.33a.4.4 0 0 1-.149.08.56.56 0 0 1-.149.034l-.286-.058a3.535 3.535 0 0 1-.824-.332 10.518 10.518 0 0 1-1.34-.859 15.152 15.152 0 0 1-1.832-1.637 14.946 14.946 0 0 1-1.625-1.82 10.029 10.029 0 0 1-.847-1.34 4.1 4.1 0 0 1-.412-1.1.557.557 0 0 1 .034-.172.378.378 0 0 1 .08-.149l1.121-1.121a1.435 1.435 0 0 0 .39-.733 1.119 1.119 0 0 0-.114-.8L16.5 11.781a1.6 1.6 0 0 0-.39-.423.86.86 0 0 0-.525-.172z",
    style: {
      fill: "#0f8560"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.2d875d70.svg";
export { ForwardRef as ReactComponent };